import ThisModule from "./AuthProvider";

export default ThisModule;
